<script>
    import DbContenedor from "./dbContenedor.svelte";
    import Router from "svelte-spa-router";
    import {db} from "./store";
    import Local from "./vistas/local.svelte";
    import Datos from "./vistas/datos.svelte";
    import Servicio from "./vistas/servicio.svelte";
    import Firma from "./vistas/firma.svelte";
    import Covid from "./vistas/covid.svelte";
    import Agradecimiento from "./vistas/agradecimiento.svelte";
    
    let routes = {
        "/": Local,
        "/datos":Datos,
        "/agradecimiento":Agradecimiento,
        "/firma":Firma,
        "/covid":Covid,
        "/servicio/":Servicio,
        "/servicio/:id":Servicio,
        "/:id": Local,
    }
</script>

<main class="w-full h-full bg-gray-200 flex flex-col items-center
justify-center">
    <Router {routes} />
</main>
